module.exports = __webpack_public_path__ + "static/media/stb-back.143c88bd.png";